module.exports = __webpack_public_path__ + "Bg_reports_Winter.6d9a0c3f793dd97ef90fbeb371c397a5.png";